import { ArrowLeftIcon, Box, Text } from '@joinrepublic/dls-ui-kit';

import { colors } from '../../config/styles';
import { IServiceItem } from './types';

interface IServiceItemProps {
  item: IServiceItem;
}

export const ServiceItem = ({
  item: { name, description, href },
}: IServiceItemProps) => {
  return (
    <Box
      as="a"
      role="group"
      href={href}
      display="block"
      pl={{ base: '9', sm: '8' }}
      position="relative"
      _hover={{ bgColor: colors.lightNavy }}
      _focusVisible={{ bgColor: colors.lightNavy, outline: 'none' }}
    >
      <Box
        py={{ base: '4', sm: '7' }}
        borderTop="1px solid"
        borderTopColor="gray.100"
      >
        <Text size={{ base: 'body-md', sm: 'body-lg' }}>{name}</Text>
        <Text
          size={{ base: 'body-sm', sm: 'body-md' }}
          variant="text-secondary"
          mt="1"
        >
          {description}
        </Text>
      </Box>

      <ArrowLeftIcon
        aria-hidden
        display={{ base: 'none', sm: 'block' }}
        position="absolute"
        top="50%"
        right="-2"
        color="gray.900"
        opacity="0"
        pointerEvents="none"
        transition="opacity 250ms, transform 250ms"
        transform="translateY(-50%) rotate(180deg) translateX(52px)"
        _groupHover={{
          sm: {
            opacity: 1,
            transform: 'translateY(-50%) rotate(180deg) translateX(36px)',
          },
        }}
        _groupFocusVisible={{
          opacity: 1,
          transform: 'translateY(-50%) rotate(180deg) translateX(36px)',
        }}
      />
    </Box>
  );
};
